export default __webpack_public_path__ + "static/media/licencse.695de2e0.svg";